import React, { Component } from "react";
import Body from "./body";
import { Layout, Menu, Button } from "antd";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  UserOutlined,
  LogoutOutlined,
  ControlOutlined,
  MessageOutlined,
  ExclamationCircleOutlined,
  BankOutlined,
  DollarCircleOutlined,
  RobotOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import "./main.scss";
import { connect } from "react-redux";
import { logout } from "../../actions/login";
import { NavLink } from "react-router-dom";
import HttpService from "../../services/http";
import socketIOClient from "socket.io-client";
import Modal from "antd/lib/modal/Modal";
import { withTranslation } from "react-i18next";
//import i18n from "../../i18n";

const { Header, Sider, Content } = Layout;

const { SubMenu } = Menu;

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(logout()),
  };
};

class ConnectedMain extends Component {
  state = {
    collapsed: false,
    selectedKey: "1",
    socket: null,
    snapped: true,
    height: window.innerHeight,
    width: window.innerWidth,
    openKeys: [],
  };

  constructor(props) {
    super(props);
    HttpService.setAxiosDefaults(props.token);
  }

  componentDidMount = async () => {
    this.setDefaultSelectedKeyForMenu();
    const socket = socketIOClient(`${process.env.REACT_APP_BASE_URL}`, {
      transports: [/* "polling", */ "websocket"],
      query: { token: this.props.token.split(" ")[1] },
      path: "/api/socket.io",
      secure: true,
    });
    this.setState({ socket: socket });

    socket.io.connect();
    /* i18n.changeLanguage(
      this.props.user.company.defaultLanguage.code.toLowerCase()
    ); */
  };

  componentWillUnmount = () => {
    HttpService.clearToken();
    if (this.state.socket) {
      this.state.socket.disconnect();
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.setDefaultSelectedKeyForMenu();
    }
  }

  handleChangeLanguage = (event) => {
    //i18n.changeLanguage(event);
  };

  setDefaultSelectedKeyForMenu = () => {
    switch (this.props.location.pathname) {
      case "/tl/system-admins":
        this.setState({ selectedKey: "1" });
        break;
      default:
        this.setState({ selectedKey: null });
        break;
    }
  };

  handleSelect = (event) => {
    this.setState({ selectedKey: event.key });
  };

  logout = async () => {
    await this.props.logout();
    this.props.history.push("/login");
  };

  toggle = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  };

  render() {
    return (
      <div style={{ height: "100%" }}>
        <Layout style={{ height: "100vh" }}>
          <Sider
            trigger={null}
            collapsible
            collapsed={this.state.collapsed}
            className={!this.state.collapsed && "sider"}
            style={{
              background: "#151917",
            }}
            /* style={{
              background:
                this.props.user.company && this.props.user.company.primaryColor
                  ? this.props.user.company.primaryColor
                  : "#ffffff",
            }} */
          >
            <div
              className={
                this.state.collapsed
                  ? "logo-container logo-container-collapsed"
                  : "logo-container"
              }
            >
              {/* {this.props.user.company && this.props.user.company.logoName ? (
                <img
                  src={`${
                    process.env.REACT_APP_BASE_URL
                  }/api/1.0.0/company/logo/${
                    this.props.user.company.logoName
                  }?token=${this.props.token.split(" ")[1]}`}
                  alt="company-logo"
                  className={
                    this.state.collapsed ? "logo-icon-collapsed" : "logo-icon"
                  }
                  /* width={this.state.collapsed ? 48 : 190}
                />
              ) : (
                <img
                  src={logo}
                  alt="tablog-logo"
                  className={
                    this.state.collapsed
                      ? "logo-icon-tablog-collapsed"
                      : "logo-icon-tablog"
                  }
                  /* width={this.state.collapsed ? 48 : 190} 
                />
              )} */}
            </div>
            <Menu
              theme="dark"
              mode="inline"
              selectedKeys={[this.state.selectedKey]}
              onSelect={this.handleSelect}
              style={{
                background: "#151917",
              }}
              onOpenChange={this.openKeys}
              subMenuOpenDelay={0}
              forceSubMenuRender
            >
              {/* {this.hasRight([1]) && (
                <Menu.Item key="4" icon={<ControlOutlined />}>
                  <NavLink to="/tl/administration" className="link-color">
                    Rendszer adminisztráció
                  </NavLink>
                </Menu.Item>
              )} */}
              {this.hasRight([1]) && (
                <SubMenu
                  icon={<ControlOutlined />}
                  key="sub2"
                  title="Rendszeradminisztráció"
                >
                  <Menu.Item key="2" icon={<DollarCircleOutlined />}>
                    <NavLink to="/tl/subscriptions" className="link-color">
                      {this.props.t("menu-subscriptions-button-label")}
                    </NavLink>
                  </Menu.Item>

                  <Menu.Item key="3" icon={<BankOutlined />}>
                    <NavLink to="/tl/companies" className="link-color">
                      {this.props.t("menu-companies-button-label")}
                    </NavLink>
                  </Menu.Item>
                </SubMenu>
              )}
              {this.hasRight([1]) && (
                <SubMenu
                  key="sub1"
                  title={this.props.t("menu-users-button-label")}
                  icon={<UserOutlined />}
                >
                  <Menu.Item key="1" icon={<UserOutlined />}>
                    <NavLink to="/tl/system-admins" className="link-color">
                      {this.props.t("menu-systemadmins-button-label")}
                    </NavLink>
                  </Menu.Item>
                  <Menu.Item key="11" icon={<UserOutlined />}>
                    <NavLink to="/tl/company-admins" className="link-color">
                      {this.props.t("menu-companyadmins-button-label")}
                    </NavLink>
                  </Menu.Item>
                  <Menu.Item key="12" icon={<UserOutlined />}>
                    <NavLink to="/tl/users" className="link-color">
                      {this.props.t("menu-users-button-label")}
                    </NavLink>
                  </Menu.Item>
                </SubMenu>
              )}
              {this.hasRight([2, 3]) && (
                <Menu.Item key="9" icon={<RobotOutlined />}>
                  <NavLink to="/tl/reception" className="link-color">
                    {this.props.t("menu-reception-button-label")}
                  </NavLink>
                </Menu.Item>
              )}
              {/* {this.hasRight([2]) && (
                <Menu.Item key="7" icon={<SettingOutlined />}>
                  <NavLink to="/tl/company-management" className="link-color">
                    {this.props.t("companyadmin-title")}
                  </NavLink>
                </Menu.Item>
              )} */}
              {this.hasRight([2]) && (
                <SubMenu
                  key="settings"
                  title={this.props.t("companyadmin-title")}
                  icon={<SettingOutlined />}
                >
                  <Menu.Item key="15">
                    <NavLink to="/tl/reg-app-tokens" className="link-color">
                      {this.props.t("companyadmin-tabstitle-regapps")}
                    </NavLink>
                  </Menu.Item>
                  <Menu.Item key="16">
                    <NavLink to="/tl/design" className="link-color">
                      {this.props.t("companyadmin-tabstitle-design")}
                    </NavLink>
                  </Menu.Item>
                  <Menu.Item key="17">
                    <NavLink to="/tl/addresses" className="link-color">
                      {this.props.t("companyadmin-tabstitle-address")}
                    </NavLink>
                  </Menu.Item>
                  <Menu.Item key="18">
                    <NavLink to="/tl/agreements" className="link-color">
                      {this.props.t("companyadmin-tabstitle-agreements")}
                    </NavLink>
                  </Menu.Item>
                  <Menu.Item key="19">
                    <NavLink to="/tl/language" className="link-color">
                      {this.props.t("companyadmin-tabstitle-language")}
                    </NavLink>
                  </Menu.Item>
                </SubMenu>
              )}
              {/* {this.hasRight([2, 3, 4]) && (
                <Menu.Item key="13" icon={<UserOutlined />}>
                  <NavLink to="/tl/profile" className="link-color">
                    {this.props.t("menu-profile-button-label")}
                  </NavLink>
                </Menu.Item>
              )}
              {this.hasRight([2, 3, 4]) && (
                <Menu.Item key="10" icon={<QuestionCircleOutlined />}>
                  <NavLink to="/tl/help" className="link-color">
                    {this.props.t("menu-help-button-label")}
                  </NavLink>
                </Menu.Item>
              )} */}
              {/* {this.hasRight([2, 4]) && (
                <Menu.Item key="8" icon={<UserOutlined />}>
                  <NavLink to="/tl/workers" className="link-color">
                    {this.props.t("menu-users-button-label")}
                  </NavLink>
                </Menu.Item>
              )} */}
              {this.hasRight([2]) ? (
                <SubMenu
                  key="workers"
                  title={this.props.t("menu-workers-button-label")}
                  icon={<UserOutlined />}
                >
                  <Menu.Item key="8" icon={<UserOutlined />}>
                    <NavLink to="/tl/workers" className="link-color">
                      {this.props.t("menu-users-button-label")}
                    </NavLink>
                  </Menu.Item>
                  <Menu.Item key="20" icon={<UserOutlined />}>
                    <NavLink to="/tl/reception-admin" className="link-color">
                      {this.props.t("companyadmin-tabstitle-reception")}
                    </NavLink>
                  </Menu.Item>
                  <Menu.Item key="21" icon={<UserOutlined />}>
                    <NavLink to="/tl/hr-admin" className="link-color">
                      {this.props.t("companyadmin-tabstitle-hr")}
                    </NavLink>
                  </Menu.Item>
                </SubMenu>
              ) : (
                this.hasRight([4]) && (
                  <Menu.Item key="8" icon={<UserOutlined />}>
                    <NavLink to="/tl/workers" className="link-color">
                      {this.props.t("menu-users-button-label")}
                    </NavLink>
                  </Menu.Item>
                )
              )}
              {this.hasRight([1, 2, 3, 4]) && (
                <Menu.Item key="5" icon={<MessageOutlined />}>
                  <NavLink to="/tl/messages" className="link-color">
                    {this.props.t("menu-messages-button-label")}
                  </NavLink>
                </Menu.Item>
              )}
              {this.hasRight([2]) && (
                <Menu.Item key="22" icon={<DollarCircleOutlined />}>
                  <a
                    href={`${process.env.REACT_APP_REDIRECT}${this.state.md5hash}?subscription_id=${this.props.user.id}`}
                    className="link-color"
                  >
                    {this.props.t("subscription-menu-label")}
                  </a>
                </Menu.Item>
              )}
              {this.hasRight([1, 2, 3]) && (
                <Menu.Item key="6" icon={<ExclamationCircleOutlined />}>
                  <NavLink to="/tl/emergency" className="link-color">
                    {this.props.t("menu-emergency-button-label")}
                  </NavLink>
                </Menu.Item>
              )}
              {this.hasRight([1, 2, 3, 4, 5]) && (
                <Menu.Item key="14" icon={<LogoutOutlined />}>
                  <NavLink className="link-color" to="*" onClick={this.logout}>
                    {this.props.t("menu-logout-button-label")}
                  </NavLink>
                </Menu.Item>
              )}
              {/* {this.props.user.company && this.props.user.company.logoName && (
                <div
                  className={
                    this.state.collapsed
                      ? "logo-container logo-container-collapsed"
                      : "logo-container"
                  }
                  style={
                    this.state.snapped
                      ? {
                          bottom: this.state.collapsed ? "0.1%" : "2%",
                          left: this.state.collapsed ? "0px" : "0px",
                          position: "absolute",
                          // height: this.state.collapsed ? "10px" : "30px",
                        }
                      : {}
                  }
                >
                  <img
                    src={logo}
                    alt="tablog-logo"
                    className={
                      this.state.collapsed ? "logo-icon-collapsed" : "logo-icon"
                    } /* width={this.state.collapsed ? 40 : 140} 
                  />
                </div>
              )} */}
            </Menu>
          </Sider>
          <Layout className="site-layout">
            <Header
              className="site-layout-background"
              style={{
                padding: "0 0 0 26px",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div style={{ display: "flex" }}>
                <div>
                  {React.createElement(
                    this.state.collapsed
                      ? MenuUnfoldOutlined
                      : MenuFoldOutlined,
                    {
                      className: "trigger",
                      onClick: this.toggle,
                    }
                  )}
                </div>
                <div>
                  {/* <Select
                    style={{ width: "130px" }}
                    value={i18n.language}
                    onChange={this.handleChangeLanguage}
                  >
                    <Select.Option key="hu" value="hu">
                      Magyar
                    </Select.Option>
                    <Select.Option key="en" value="en">
                      English
                    </Select.Option>
                    <Select.Option key="de" value="de">
                      Deutsch
                    </Select.Option>
                  </Select> */}
                </div>
              </div>
              <div style={{ float: "right" }}>
                {/*  {this.hasRight([2]) && ( */}
                <NavLink to="/tl/help">
                  <Button type="link">
                    {this.props.t("menu-help-button-label")}
                  </Button>
                </NavLink>
                {/*  )} */}
                <NavLink to="/tl/profile">
                  <Button
                    size="large"
                    //overlay={this.renderMenu}
                    icon={<UserOutlined />}
                    style={{
                      //float: "right",
                      margin: "12px 26px 0 0",
                    }}
                  />
                </NavLink>
              </div>
            </Header>
            <Content
              className="site-layout-background"
              style={{
                margin: "24px 16px",
                padding: 24,
                //height: "100%",
                //minHeight: "800px",
              }}
            >
              <Body socket={this.state.socket} />
            </Content>
          </Layout>
        </Layout>
        <Modal
          visible={this.props.emergency}
          title={this.props.t("emergency-popup-title")}
          //onOk={this.handleDeactivateEmergency}
          closable={false}
          footer={[
            <Button
              key="submit"
              type="primary"
              onClick={this.handleDeactivateEmergency}
            >
              {this.props.t("emergency-popup-button-label")}
            </Button>,
          ]}
          maskClosable={false}
        >
          {this.props.t("emergency-popup-title")}
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  token: state.loginReducer.token,
  user: state.loginReducer.user,
  emergency: state.emergencyReducer.emergency,
  apiKey: state.loginReducer.apiKey,
});

const Main = withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(ConnectedMain)
);
export default Main;
